import React, { Component, useEffect, useState } from "react";
import { withStyles } from "@material-ui/core/styles";
import runtimeEnv from "@mars/heroku-js-runtime-env";
import axios from "axios";
import PropTypes from "prop-types";
import { Typography } from "@material-ui/core";
import ResponsiveMobileStepper from "./ResponsiveMobileStepper";
import NextBackButtons from "./NextBackButtons";
import Grid from "@material-ui/core/Grid";
import CircularProgress from "@material-ui/core/CircularProgress";
import moment from "moment";
import ReactTimeslotCalendar from "react-timeslot-calendar";
import { date } from "yup";

const times = ["08", "10", "12", "14"];

const styles = (theme) => ({
  root: {
    textAlign: "center",
  },
  introText: {
    fontSize: 32,
    maxWidth: 775,
    paddingBottom: theme.spacing(8),
  },
  styleItalic: {
    fontStyle: "italic",
  },
  ReactTimeslotCalendarWrapper: {
    //We style the ReactTimeslotCalendar using global styles becuase it uses scss internally
    "@global .tsc-calendar": {
      background: "none",
    },
    "@global .tsc-calendar__actions": {
      display: "none",
    },
    "@global .tsc-month": {
      background: "none",
    },
    "@global .tsc-month__action": {
      color: "#000F9F",
    },
    "@global .tsc-day__title": {
      color: "#000F9F",
      fontWeight: 600,
      textTransform: "none",
    },
    "@global .tsc-timeslot": {
      transition: "none",
    },
    "@global .tsc-timeslot:not(.tsc-timeslot--disabled):hover": {
      backgroundColor: "#000F9F",
    },
    "@global .tsc-timeslot--selected:not(.tsc-timeslot--disabled):hover": {
      backgroundColor: "rgb(0, 10, 111)",
    },
    "@global .tsc-timeslot--selected": {
      backgroundColor: "rgb(0, 10, 111)",
    },
  },
});

const Schedule = (props) => {
  const [disabledTimeslots, setDisabledTimeslots] = useState([]);
  const [timeslots, setTimeslots] = useState();
  const [currentDate, setCurrentDate] = useState(
    (props.values.length && props.values[0].startDate) ||
      moment(props.movingDate)
  ); // If a timeslot has already been chosen, use that - otherwise, use movingDate
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (props.values) {
      let newVals = [];
      props.values.forEach((v) => {
        newVals.push({
          startDate: new moment(v.startDate),
          endDate: new moment(v.endDate),
        });
      });
      setTimeslots(newVals);
    } else {
      setTimeslots([]);
    }
  }, [props]);

  const fetchSchedule = () => {
    setLoading(true);

    return axios
      .request({
        method: "get",
        url: runtimeEnv().REACT_APP_API_URL + "/openings",
        params: {
          hours: props.hours,
          numberOfTrucks: props.numberOfTrucks,
        },
      })
      .then((response) => {
        const disabledTimeslots = [];

        for (const [date, trucks] of Object.entries(response.data)) {
          trucks.forEach((truck, index) => {
            if (truck - props.numberOfTrucks < 0) {
              disabledTimeslots.push({
                startDate: date + " " + times[index] + ":00:00",
                format: "YYYY-MM-DD HH:mm:ss",
              });
            }
          });
        }
        setDisabledTimeslots(disabledTimeslots);
        setLoading(false);
      })
      .catch((error) => {
        console.log(error); //eslint-disable-line no-console
        console.log(error.response); //eslint-disable-line no-console

        setLoading(false);
      });
  };

  useEffect(() => {
    fetchSchedule();
  }, []);

  const nextButtonClick = () => {
    window.dataLayer.push({
      event: "schedule-date-time",
      eventProps: {
        category: "Ecommerce",
        action: "Click",
        label: "Page 7 - Schedule Date & Time",
      },
    });

    if (timeslots.length) {
      setLoading(true);
      axios
        .request({
          method: "post",
          url: runtimeEnv().REACT_APP_API_URL + "/estimate",
          data: {
            ...props.estimateValues,
            movingDateTime: moment(timeslots[0].startDate).format(
              "YYYY-MM-DDTHH:mm:ss"
            ),
          },
        })
        .then((response) => {
          console.log(response.data);
          props.updateQuote({
            ...response.data,
            amount_off: 0,
            percent_off: 0,
          });
          props.handleNext(timeslots);
        })
        .finally(() => setLoading(false));
    } else {
      //show some kind of error?
      setError("Please select a time slot");
    }
  };

  const { classes } = props;

  let availableTimeslots = [];

  // if (this.props.hours > 11) {
  //   availableTimeslots = [];
  // } else
  if (props.hours >= 8) {
    availableTimeslots = [["8", "9"]];
  } else if (props.hours >= 6) {
    availableTimeslots = [
      ["8", "9"],
      ["10", "11"],
    ];
  } else if (props.hours >= 3.5) {
    availableTimeslots = [
      ["8", "9"],
      ["10", "11"],
      ["12", "13"],
    ];
    // } else if (this.props.hours > 3) {
  } else {
    availableTimeslots = [
      ["8", "9"],
      ["10", "11"],
      ["12", "13"],
      ["14", "15"],
    ];
  }
  // } else {
  //   availableTimeslots = [["8"], ["10"], ["12"], ["14"], ["16"]];
  // }

  return (
    (loading && (
      <div style={{ margin: "40px auto 40px auto", textAlign: "center" }}>
        <CircularProgress />
      </div>
    )) || (
      <Grid className={classes.root}>
        <Grid item>
          <Typography variant="h4" component="h4">
            Confirm your moving date and start time
          </Typography>

          <Typography className={classes.styleItalic}>
            Greyed out times are already booked
          </Typography>

          {error && <Typography color={"error"}>{error}</Typography>}

          <div
            className={classes.ReactTimeslotCalendarWrapper} //required to style the ReactTimeslotCalendar using JSS
          >
            <ReactTimeslotCalendar
              // currentDate={currentDate.format()} //if a timeslot has already been chosen, use that - otherwise, use movingDate
              initialDate={moment().startOf("day").add(3, "days").format()} //always have 3 days from now as the earliest booking time
              timeslots={availableTimeslots}
              selectedTimeslots={timeslots || []}
              disabledTimeslots={disabledTimeslots}
              // eslint-disable-next-line no-unused-vars
              onSelectTimeslot={(allTimeslots, lastSelectedTimeslot) => {
                /**
                  * All timeslot objects include `startDate` and `endDate`.

                  * It is important to note that if timelots provided contain a single
                  * value (e.g: timeslots = [['8'], ['9', '10']) then only `startDate` is filled up with
                  * the desired information.
                  */
                setTimeslots(allTimeslots);
              }}
            />
          </div>
        </Grid>
        <NextBackButtons
          backOnClick={props.handleBack}
          nextOnClick={nextButtonClick}
          nextLabel="Continue to Checkout"
        />
        <ResponsiveMobileStepper
          steps={props.steps}
          activeStep={props.activeStep}
          backOnClick={props.handleBack}
          nextOnClick={nextButtonClick}
          nextLabel="Checkout"
        />
      </Grid>
    )
  );
};

Schedule.propTypes = {
  classes: PropTypes.object.isRequired,
  steps: PropTypes.number.isRequired,
  activeStep: PropTypes.number.isRequired,
  values: PropTypes.array.isRequired,
  movingDate: PropTypes.object, //moment object
  numberOfTrucks: PropTypes.number,
  hours: PropTypes.number,
  handleBack: PropTypes.func.isRequired,
  handleNext: PropTypes.func.isRequired,
  estimateValues: PropTypes.object.isRequired,
  updateQuote: PropTypes.func.isRequired,
};

export default withStyles(styles)(Schedule);
